import React, { useState } from "react";
import "./GoogleSignIn.css";
import { API_URL } from "../config";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  getFirebaseAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "../services/firebase";

const GoogleSignIn = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [loading, setLoading] = useState(false);

  const persistSession = (data, profileResponse) => {
    const userData = {
      email: profileResponse.email,
      name: profileResponse.name,
      picture: profileResponse.picture,
      subscription_type: profileResponse.subscription_type || 0,
      subscription_end_date: profileResponse.subscription_end_date,
      account_type: profileResponse.account_type,
      dot_authorized: profileResponse.dot_authorized ?? false,
      is_first_login: data.is_first_login,
    };
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("user", JSON.stringify(userData));
    updateUser(userData);
    if (data.is_first_login || !userData.account_type) {
      navigate("/onboarding", { replace: true });
      return;
    }
    navigate("/load-search", { replace: true });
  };

  const handleGoogleLogin = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const auth = getFirebaseAuth();
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const response = await fetch(`${API_URL}/auth/firebase/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id_token: idToken }),
      });

      if (!response.ok) {
        throw new Error("Failed to exchange Firebase token");
      }

      const data = await response.json();
      persistSession(data, data);
    } catch (error) {
      console.error("Error initiating Google login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className="google-signin-button"
      onClick={handleGoogleLogin}
      disabled={loading}
    >
      <img
        src="https://developers.google.com/identity/images/g-logo.png"
        alt="Google logo"
        className="google-logo"
      />
      {loading ? "Signing in..." : "Sign in with Google"}
    </button>
  );
};

export default GoogleSignIn;
